import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import withAuth from "../../../hoc/withAuth/withAuth";
import AnimatedCard from "../../../components/AnimatedCard/AnimatedCard";
import { Button, colors, InnerCard } from "@repo/ui";
import PageContainer from "../../../components/PageContainer/PageContainer";
import { RootState } from "../../../redux/store";
import {
  choosePlan,
  publishGiftTable,
} from "../../../redux/slices/giftTableSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/useAppDispatch";
import { fetchPurchasePricing } from "../../../redux/slices/pricingSlice";

import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_pages_ChoosePlan";

const ChoosePlan: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const giftTableID = useAppSelector((state: RootState) => state.giftTable.ID);

  const purchaseTotalCharge = useAppSelector(
    (state: RootState) => state.pricing.purchaseState.totalCharge
  );

  useEffect(() => {
    dispatch(fetchPurchasePricing({ country: "MX" }));
  }, [dispatch]);

  const handleSelectPlan = async (plan: string) => {
    if (giftTableID) {
      try {
        await dispatch(choosePlan(giftTableID, plan));
        if (plan === "prepay") {
          navigate("/my-table/prepay");
        } else if (plan === "percentage") {
          await dispatch(publishGiftTable(giftTableID));
          navigate("/my-table/share");
        }
      } catch (error) {
        console.error("Error processing plan selection:", error);
      }
    } else {
      console.error("GiftTable ID not found");
    }
  };

  return (
    <PageContainer startColor="white" endColor={colors.background}>
      <div className="mt-16"></div>
      <AnimatedCard title={t("title")} className="bg-white max-w-4xl w-full">
        <p className="mb-8">{t("description")}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="flex flex-col justify-between h-full">
            <InnerCard className="flex flex-col h-full p-8 items-center text-center">
              <h3 className="font-bold text-xl mb-4">{t("one-time-title")}</h3>
              <p className="text-3xl mb-4">
                {purchaseTotalCharge
                  ? purchaseTotalCharge.toLocaleString("es-MX", {
                      style: "currency",
                      currency: "MXN",
                    })
                  : t("calculating")}
              </p>
              <p className="text-sm">{t("one-time-description")}</p>
            </InnerCard>
            <Button
              label={t("select-one-time-button")}
              onClick={() => handleSelectPlan("prepay")}
              type="primary"
              className="w-full mt-4"
            />
          </div>
          <div className="flex flex-col justify-between h-full">
            <InnerCard className="flex flex-col h-full p-8 items-center text-center">
              <h3 className="font-bold text-xl mb-4">
                {t("commission-title")}
              </h3>
              <p className="text-3xl mb-4">{t("commission-rate")}</p>
              <p className="text-sm">{t("commission-description")}</p>
            </InnerCard>
            <Button
              label={t("select-commission-button")}
              onClick={() => handleSelectPlan("percentage")}
              type="primary"
              className="w-full mt-4"
            />
          </div>
        </div>
      </AnimatedCard>
    </PageContainer>
  );
};

export default withAuth(withTranslations(LOCALE)(ChoosePlan));
